import { render, staticRenderFns } from "./FormBaseComponentEmpty.vue?vue&type=template&id=45411262"
import script from "./FormBaseComponentEmpty.ts?vue&type=script&lang=ts&external"
export * from "./FormBaseComponentEmpty.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports